import React from 'react';
import * as Render from '../../platformui/Base/Render';
import SectionStartPage from '../../platformui/Pages/sectionstart';

import IntroBlock from '../../blocks/intro-block';
import PageListBlock from '../../blocks/page-list-block';
import ManuelPageListBlock from '../../blocks/manuel-page-list-block';
import ImageBlock from '../../blocks/image-block';
import ListContainerBlock from '../../blocks/list-container-block';
import SearchLinkListBlock from '../../blocks/search-link-list-block';

const Blocks = {
  IntroBlock,
  PageListBlock,
  ManuelPageListBlock,
  ImageBlock,
  SearchLinkListBlock,
  ListContainerBlock,
};

const blockTypes = <Render.BlockTypeRenderer Blocks={Blocks} />;
export default (props) => (
  <SectionStartPage {...props} BlockTypeRenderer={blockTypes} />
);